import { type RefObject, useEffect } from 'react';
import { type GraphComponent, GraphViewerInputMode } from '@ardoq/yfiles';

const updateToolTipParentElement = (
  graphComponentRef: RefObject<GraphComponent | null>
): void => {
  const graphComponent = graphComponentRef.current;
  if (!(graphComponent?.inputMode instanceof GraphViewerInputMode)) {
    return;
  }
  graphComponent.inputMode.popoverManager.defaultParentElement =
    document.fullscreenElement instanceof HTMLElement
      ? document.fullscreenElement
      : null;
};

export const useToolTipParentElement = (
  graphComponentRef: RefObject<GraphComponent | null>
): void => {
  useEffect(() => {
    updateToolTipParentElement(graphComponentRef);
    const update = (): void => updateToolTipParentElement(graphComponentRef);

    document.addEventListener('fullscreenchange', update);
    return () => document.removeEventListener('fullscreenchange', update);
  }, [graphComponentRef]);
};
